export const errorMessages = {
    400: "Bad Request. The server could not understand the request.",
    401: "Unauthorized access. Please check your authentication token or log in again.",
    403: "You do not have permission to access this resource. Contact a staff member to assign you the permissions to access this page.",
    404: "Page Not Found.",
    500: "Internal Server Error - Something went wrong on the server.",
};
  
export function formatError(error) {
    if (error.response) {
        const code = error.response.status;
        const message = errorMessages[code] || 'Unexpected Error';
        return { code :`${code}`, message:`${message}`}
    } else {
        return 'Unknown Error';
    }
};

// Extracts a readable message from a DRF error response, falls back to the provided default
export function extractErrorMessage(error, fallback) {
    const data = error?.response?.data;
    if (!data || typeof data !== 'object') return fallback;
    if (Array.isArray(data)) return data[0] ?? fallback;
    if (data.detail) return Array.isArray(data.detail) ? data.detail[0] : data.detail;
    if (data.non_field_errors) return Array.isArray(data.non_field_errors) ? data.non_field_errors[0] : data.non_field_errors;
    return fallback;
};
  